import React from 'react';

const FiatCurrency = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.4167 12.7498C13.5463 12.7498 16.0833 10.2128 16.0833 7.08317C16.0833 3.95356 13.5463 1.4165 10.4167 1.4165C7.28705 1.4165 4.75 3.95356 4.75 7.08317C4.75 10.2128 7.28705 12.7498 10.4167 12.7498Z",
      stroke: "#434B53",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.73623 7.7915C2.2182 8.58314 1.91699 9.5294 1.91699 10.5461C1.91699 13.328 4.17217 15.5832 6.95407 15.5832C7.97076 15.5832 8.91703 15.282 9.70866 14.7639",
      stroke: "#434B53",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.6708 5.81199C11.5177 5.1659 10.7382 4.58289 9.8026 5.01905C8.86696 5.45521 8.71835 6.85852 10.1336 7.0076C10.7733 7.07498 11.1903 6.92941 11.5722 7.34119C11.9539 7.75294 12.0249 8.89803 11.0488 9.20665C10.0728 9.51527 9.10623 9.03304 9.00098 8.34836M10.4065 4.25293V4.8685M10.4065 9.30164V9.91959",
      stroke: "#434B53",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
FiatCurrency.displayName = "Icons.FiatCurrency";

export { FiatCurrency };
//# sourceMappingURL=FiatCurrency.js.map
